var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      attrs: { width: "75%" },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function ({ on, attrs }) {
              return [_vm._t("clickable", null, { on: on, attrs: attrs })]
            },
          },
        ],
        null,
        true
      ),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm.update_unavailable
        ? _c("v-banner", { attrs: { icon: "mdi-alert", color: "warning" } }, [
            _vm._v(
              " Some of the settings are managed by your identity provider. "
            ),
          ])
        : _vm._e(),
      _c(
        "v-card",
        { staticClass: "rounded-t-0" },
        [
          _c(
            "v-card-title",
            {
              staticClass: "headline grey",
              attrs: { "data-cy": "userModalTitle", "primary-title": "" },
            },
            [_vm._v(_vm._s(_vm.title))]
          ),
          _vm.userInfo === null
            ? _c(
                "v-card-text",
                [
                  _c("v-progress-linear", {
                    staticClass: "mb-0",
                    attrs: { indeterminate: "", color: "white" },
                  }),
                ],
                1
              )
            : _c(
                "v-card-text",
                [
                  _c("br"),
                  _c(
                    "v-form",
                    { attrs: { "data-cy": "updateUserForm" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  id: "firstName",
                                  disabled: _vm.update_unavailable,
                                  label: "First Name",
                                  "aria-autocomplete": "both",
                                  autocomplete: "given-name",
                                },
                                model: {
                                  value: _vm.userInfo.firstName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.userInfo, "firstName", $$v)
                                  },
                                  expression: "userInfo.firstName",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  id: "lastName",
                                  disabled: _vm.update_unavailable,
                                  label: "Last Name",
                                  "aria-autocomplete": "both",
                                  autocomplete: "family-name",
                                },
                                model: {
                                  value: _vm.userInfo.lastName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.userInfo, "lastName", $$v)
                                  },
                                  expression: "userInfo.lastName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  id: "email_field",
                                  disabled: _vm.update_unavailable,
                                  "error-messages": _vm.emailErrors(
                                    _vm.$v.userInfo.email
                                  ),
                                  label: "Email",
                                  type: "email",
                                  required: "",
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.$v.userInfo.email.$touch()
                                  },
                                },
                                model: {
                                  value: _vm.userInfo.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.userInfo, "email", $$v)
                                  },
                                  expression: "userInfo.email",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.admin
                            ? _c(
                                "v-col",
                                [
                                  _c("v-select", {
                                    attrs: { items: _vm.roles, label: "Role" },
                                    model: {
                                      value: _vm.userInfo.role,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.userInfo, "role", $$v)
                                      },
                                      expression: "userInfo.role",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  id: "title",
                                  disabled: _vm.update_unavailable,
                                  label: "Title",
                                },
                                model: {
                                  value: _vm.userInfo.title,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.userInfo, "title", $$v)
                                  },
                                  expression: "userInfo.title",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  id: "organization",
                                  disabled: _vm.update_unavailable,
                                  label: "Organization",
                                },
                                model: {
                                  value: _vm.userInfo.organization,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.userInfo, "organization", $$v)
                                  },
                                  expression: "userInfo.organization",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showAPIKeys,
                              expression: "showAPIKeys",
                            },
                          ],
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex flex-row-reverse",
                              staticStyle: { cursor: "pointer" },
                              on: { click: _vm.addAPIKey },
                            },
                            [
                              _c("span", { staticClass: "pt-1" }, [
                                _vm._v("Add API Key"),
                              ]),
                              _c("v-icon", [_vm._v("mdi-plus")]),
                            ],
                            1
                          ),
                          _c("InputDialog", {
                            attrs: {
                              "show-modal": _vm.inputPasswordDialog,
                              title:
                                "Please enter your current password to update API keys",
                              "text-field-label": "Current Password",
                              "is-password": true,
                            },
                            on: {
                              "update-value": _vm.updateCurrentPassword,
                              cancel: function ($event) {
                                _vm.inputPasswordDialog = false
                              },
                              confirm: _vm.updateCallback,
                            },
                          }),
                          _c("v-data-table", {
                            staticClass: "overflow-y-auto",
                            staticStyle: { "max-height": "300px" },
                            attrs: {
                              headers: _vm.apiKeyHeaders,
                              items: _vm.apiKeys,
                              loading: _vm.apiKeyTableLoading,
                              dense: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: `item.name`,
                                  fn: function ({ item }) {
                                    return [
                                      _c("v-text-field", {
                                        on: {
                                          change: function ($event) {
                                            return _vm.updateAPIKey(item)
                                          },
                                        },
                                        model: {
                                          value: item.name,
                                          callback: function ($$v) {
                                            _vm.$set(item, "name", $$v)
                                          },
                                          expression: "item.name",
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: `item.apiKey`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "break-lines" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.apiKey ||
                                                "Only Shown on Creation"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: `item.action`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { left: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.refreshAPIKey(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          "v-icon",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [_vm._v("mdi-refresh")]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v("Recreate this API Key"),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      _vm._g(
                                                        _vm._b(
                                                          {},
                                                          "span",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        item.apiKey
                                                          ? _c("CopyButton", {
                                                              attrs: {
                                                                text: item.apiKey,
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v("Copy this API Key"),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { right: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deleteAPIKey(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          "v-icon",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [_vm._v("mdi-delete")]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v("Delete this API Key"),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      !_vm.admin && _vm.userInfo.creationMethod === "local"
                        ? _c(
                            "div",
                            [
                              _c("v-divider"),
                              _c("v-text-field", {
                                ref: "password",
                                attrs: {
                                  id: "password_field",
                                  disabled: _vm.update_unavailable,
                                  "error-messages": _vm.requiredFieldError(
                                    _vm.$v.currentPassword,
                                    "Current Password"
                                  ),
                                  type: "password",
                                  label:
                                    "Please provide your current password to make changes to your profile",
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.$v.currentPassword.$touch()
                                  },
                                },
                                model: {
                                  value: _vm.currentPassword,
                                  callback: function ($$v) {
                                    _vm.currentPassword = $$v
                                  },
                                  expression: "currentPassword",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.userInfo.creationMethod === "local"
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                id: "toggleChangePassword",
                                disabled: _vm.update_unavailable,
                              },
                              on: { click: _vm.changePasswordDialog },
                            },
                            [_vm._v("Change Password")]
                          )
                        : _vm._e(),
                      _vm.apiKeysEnabled
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "ml-2",
                              attrs: { id: "toggleAPIKeys" },
                              on: { click: _vm.toggleShowAPIKeys },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.showAPIKeys
                                    ? "Hide API Keys"
                                    : "Show API Keys"
                                ) + " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.changePassword,
                              expression: "changePassword",
                            },
                          ],
                        },
                        [
                          _c("v-text-field", {
                            ref: "newPassword",
                            attrs: {
                              id: "new_password_field",
                              disabled: _vm.update_unavailable,
                              "error-messages": _vm.requiredFieldError(
                                _vm.$v.newPassword,
                                "New Password"
                              ),
                              type: "password",
                              label: "New Password",
                            },
                            on: {
                              blur: function ($event) {
                                return _vm.$v.newPassword.$touch()
                              },
                            },
                            model: {
                              value: _vm.newPassword,
                              callback: function ($$v) {
                                _vm.newPassword = $$v
                              },
                              expression: "newPassword",
                            },
                          }),
                          _c("v-text-field", {
                            ref: "repeatPassword",
                            attrs: {
                              id: "repeat_password_field",
                              disabled: _vm.update_unavailable,
                              "error-messages": _vm.requiredFieldError(
                                _vm.$v.passwordConfirmation,
                                "Repeat Password"
                              ),
                              type: "password",
                              label: "Repeat Password",
                            },
                            on: {
                              blur: function ($event) {
                                return _vm.$v.passwordConfirmation.$touch()
                              },
                            },
                            model: {
                              value: _vm.passwordConfirmation,
                              callback: function ($$v) {
                                _vm.passwordConfirmation = $$v
                              },
                              expression: "passwordConfirmation",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c(
                "v-col",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        id: "closeAndDiscardChanges",
                        color: "primary",
                        text: "",
                      },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [_vm._v("Close without saving")]
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "text-right" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        id: "closeAndSaveChanges",
                        color: "primary",
                        text: "",
                        disabled: !_vm.admin && _vm.update_unavailable,
                        loading: _vm.buttonLoading,
                      },
                      on: { click: _vm.updateUserInfo },
                    },
                    [_vm._v("Save Changes")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }